import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import clsx from "clsx";
import { Fragment, isValidElement, ReactNode } from "react";

import { Button } from "@/features/common/components/Button";

type FilterButtonProps = {
  value: string | number;
  filterOptionItem: ReactNode | ((close: () => void) => ReactNode);
  sideMenu?: ReactNode;
  hasButton?: boolean;
  renderChip: (args: { value: string | number }) => ReactNode | string;
  onApply?: () => void;
  onClear?: () => void;
  children?: ReactNode;
};

export const FilterDropDown = (
  {
    value,
    filterOptionItem,
    sideMenu = null,
    hasButton = true,
    renderChip,
    onApply = () => {},
    onClear = () => {},
  }: FilterButtonProps,
) => {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            as={Button}
            variant="outlineDark"
            className={clsx(
              !!value
                ? "!border-primary !text-primary ring-primary ring-1"
                : "!border-gray-400 !text-gray-500 hover:!bg-gray-200",
              "justify-between !rounded-full !bg-white !px-4 !font-light w-fit",
            )}
          >
            {renderChip({ value })}
            <ChevronDownIcon className="h-5 w-5" />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-50 mt-2 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {({ close }) => (
                <div className="flex">
                  {sideMenu && (
                    <div className="border-r border-solid border-gray-300">
                      {sideMenu}
                    </div>
                  )}
                  <div
                    className={clsx(
                      hasButton && "min-w-[13rem] px-3",
                      "w-max space-y-3 px-2 py-4",
                    )}
                  >
                    <>
                      {isValidElement(filterOptionItem)
                        ? filterOptionItem
                        : (
                            filterOptionItem as (close: () => void) => ReactNode
                          )(close)}
                      {hasButton && (
                        <div className="flex justify-between space-x-1">
                          <Button
                            className="!px-4 !py-2"
                            variant="text"
                            onClick={() => {
                              onClear();
                              close();
                            }}
                          >
                            清除
                          </Button>
                          <Button
                            className="!px-4 !py-2"
                            onClick={() => {
                              onApply();
                              close();
                            }}
                          >
                            提交
                          </Button>
                        </div>
                      )}
                    </>
                  </div>
                </div>
              )}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};
